<!-- <ol id="cust-breadcrumb">
  <li><a routerLink="" class="cust-breadcrumb">Home</a></li>
  <li *ngFor="let breadcrumb of breadcrumbs">
    <a [routerLink]="[breadcrumb.url, breadcrumb.params]">{{breadcrumb.label}}</a>
  </li>
</ol> -->


<p class="main-breadcrumb-wrapper font-col-secondary">

  <a routerLink="" class="cust-breadcrumb">Home</a>
    
    <ng-container *ngFor="let breadcrumb of breadcrumbs">
        &nbsp;&nbsp;>&nbsp;&nbsp;
      <a [routerLink]="[breadcrumb.url]" (click)="onClick()" style="text-transform: capitalize;">
        {{breadcrumb.label}}
      </a>
    </ng-container>
</p>